export function singlebuttongroup(fieldId: string, value: number, max: number, beforeSubmit?: Function, afterSubmit?: Function, requiredQuantity: number | null = null) {

    const containerEle = document.getElementById('container_' + fieldId);
    const element = document.getElementById('input_' + fieldId);
    const buttons = containerEle.getElementsByClassName("amount-button")
    const css_amount_selected = "amount-selected";

    var initialized = containerEle.hasAttribute("data-singlebuttongroup");

    for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i] as HTMLButtonElement;

        const buttonVal = (button.textContent || "").trim();

        const buttonEle = button as HTMLButtonElement;

        if (parseInt(buttonVal) === value) {
            button.classList.add(css_amount_selected);
        } else {
            button.classList.remove(css_amount_selected);
        }

        button.disabled = parseInt(buttonVal) > max ||
            (requiredQuantity !== null && parseInt(buttonVal) !== requiredQuantity);
        button.classList.toggle("disabled", button.disabled);
        button.setAttribute("aria-disabled", String(button.disabled));

        buttonEle.onclick = function () {
            if (buttonEle.disabled) {
                return;
            }

            const dataEle = document.getElementById('data_' + fieldId);

            dataEle.setAttribute('value', buttonVal === value.toString() ? "0" : buttonVal);

            if (beforeSubmit) {
                beforeSubmit();
            }

            ((window as any).htmx as any).trigger('#updatebutton', 'click');

            if (afterSubmit) {
                afterSubmit();
            }
        }
    }

    if (!initialized) {
        containerEle.setAttribute('data-singlebuttongroup', 'true');
        containerEle.style.display = null;
    }
}
